<template>
  <div class="job-detail">
    <h1>{{ jobDetail.title }}</h1>

    <div v-if="Array.isArray(jobDetail.description)">
      <div v-for="(block, index) in jobDetail.description" :key="index" class="desc-block">
        <p v-if="block.type === 'paragraph'">{{ block.text }}</p>

        <div v-else-if="block.type === 'list'">
          <h3 v-if="block.title">{{ block.title }}</h3>
          <ul>
            <li v-for="(item, i) in block.items" :key="i">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>
    <p v-else>{{ jobDetail.description }}</p>

    <router-link to="/careers" class="back-link">{{ backText }}</router-link>
  </div>
</template>


<script>
export default {
  name: 'JobDetail',
  props: {
    language: {
      type: String,
      default: 'zh-CN' // 默认语言
    }
  },
  data() {
    return {
      jobDetail: {
        title: '',
        description: ''
      }
    };
  },
  watch: {
    language: {
      immediate: true,
      handler(newLang) {
        this.loadJobDetail(this.$route.params.id, newLang);
      }
    }
  },
  computed: {
    // 计算属性，根据语言返回相应的文本
    backText() {
      return this.language === 'en-US' ? 'Back' : '返回';
    }
  }, 
  methods: {
    async loadJobDetail(jobId, lang) {
      try {
        const response = await fetch(`/locales/${lang}.json`);
        const data = await response.json();
        
        // 确保 jobId 是字符串，以匹配 JSON 中的 ID
        const job = data.careers.jobs.find(job => job.id.toString() === jobId);

        if (job) {
          this.jobDetail = job;
        } else {
          console.warn(`职位 ID ${jobId} 未找到`);
          this.jobDetail = {
            title: '职位未找到',
            description: '很抱歉，未找到该职位信息。'
          };
        }
      } catch (error) {
        console.error('职位详情加载失败:', error);
        this.jobDetail = {
          title: '加载失败',
          description: '职位详情加载失败，请稍后再试。'
        };
      }
    }
  },
  mounted() {
    this.loadJobDetail(this.$route.params.id, this.language);
  }
};
</script>

<style scoped>
.desc-block {
  margin-bottom: 28px;
  line-height: 1.9;
  letter-spacing: 0.4px;
  font-family: 'Roboto Mono', 'Noto Sans SC', sans-serif;
}

.desc-block h3 {
  font-size: 22px;
  color: #ffffff;
  margin-bottom: 12px;
  font-weight: 600;
  letter-spacing: 0.6px;
}

.desc-block ul {
  padding-left: 24px;
  list-style: disc;
  color: #ffffff;
  line-height: 2;
  font-size: 17px;
  font-family: 'Roboto Mono', 'Noto Sans SC', sans-serif;
}

.job-detail {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 65%;
  margin: 0 auto;
  padding: 40px;
}

h1 {
  color: #ffffff;
  font-size: 48px;
  font-weight: bold;
  font-family: 'Orbitron', sans-serif;
  margin-bottom: 30px;
}

p {
  font-size: 20px;
  color: #ffffff;
  line-height: 1.8;
  text-align: center;
  font-family: 'Roboto Mono', monospace;
  margin-bottom: 30px;
  opacity: 0.9;
}

.back-link {
  font-size: 20px; /* 与 p 一致 */
  color: #ffffff; /* 与 p 一致 */
  font-family: 'Roboto Mono', 'Noto Sans SC', sans-serif;
  line-height: 1.8;
  text-align: center;
  text-decoration: none;
  margin-top: 20px;
  transition: color 0.3s ease;
  opacity: 0.9; /* 与 p 一致 */
}

.back-link:hover {
  color: #c7dada;
  transform: translateX(5px);
}
</style>
